import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Dropdown from 'common/components/Dropdown';

const renderDefault = () => <div className="default text">Produit</div>;

const renderProduct = product => (
  <div key={product.id} data-value={product.id} className="item">
    {product.name}
  </div>
);

export const ProductDropdown = ({ value, products, onChange }) => (
  <Dropdown
    name="product_id"
    value={value}
    canDelete
    items={products}
    renderDefault={renderDefault}
    renderItem={renderProduct}
    onChange={onChange}
  />
);

ProductDropdown.propTypes = {
  value: PropTypes.string,
  products: ImmutablePropTypes.set.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ProductDropdown;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/components/ProductDropdown.js